module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "top": "0px",
      "right": "0px"
    }
  }, [_c('div', {
    attrs: {
      "id": "favorites"
    }
  }, [(_vm.type === 'FAV') ? _c('div', {
    staticClass: "flexContainer ai-c jc-sb",
    attrs: {
      "id": "searchInputWrapper"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "full",
    attrs: {
      "id": "searchInput",
      "type": "search",
      "placeholder": _vm.$t('common.search')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ai-c"
  }, [(_vm.search !== '') ? _c('img', {
    staticClass: "cross pointer",
    attrs: {
      "id": "cross",
      "src": require("../../../assets/cross.png"),
      "alt": "",
      "width": "10",
      "height": "10"
    },
    on: {
      "click": _vm.reset
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ai-c"
  }, [_c('img', {
    staticClass: "pointer",
    attrs: {
      "id": "glass",
      "src": require("../../../assets/loupe.png")
    },
    on: {
      "click": _vm.submit
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.type === 'FAV') ? _c('div', {
    staticClass: "flexContainer"
  }, [_c('div', {
    staticClass: "center btnsFilter"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('button', {
      staticClass: "filterBtn",
      on: {
        "click": function($event) {
          _vm.filterAction(filter);
        }
      }
    }, [_vm._v(_vm._s(_vm.getLabel(filter)))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "flexContainer abs",
    attrs: {
      "id": "spinnerLoader"
    }
  }, [_c('Spinner', {
    staticClass: "loader",
    attrs: {
      "animation-duration": 5000,
      "size": 60,
      "color": '#41b4e8'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getFavorites.length === 0 && _vm.loading === false) ? _c('div', {
    staticClass: "flexContainer abs full",
    attrs: {
      "id": "noResults"
    }
  }, [(_vm.type === 'FAV') ? _c('h3', {
    staticClass: "uppercase txtCenter"
  }, [_vm._v(_vm._s(_vm.$t("favorite.noFavorite")))]) : _c('h3', {
    staticClass: "uppercase txtCenter"
  }, [_vm._v(_vm._s(_vm.$t("scratchPad.noScratch")))])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "scrollY flexContainer fw-w",
    attrs: {
      "id": "favoritesContent"
    }
  }, _vm._l((_vm.getFavorites), function(fav) {
    return _c('div', [_c('div', {
      staticStyle: {
        "height": "auto",
        "width": "100px",
        "position": "relative",
        "margin": "10px",
        "overflow": "hidden"
      }
    }, [_c('img', {
      staticStyle: {
        "position": "absolute",
        "right": "5px"
      },
      attrs: {
        "src": require("../../../assets/croix.png")
      },
      on: {
        "click": function($event) {
          _vm.deleteFav(fav.id, fav.name);
        }
      }
    }), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.getUrlFav(fav),
        "width": "100px",
        "height": "auto"
      },
      on: {
        "mousedown": function($event) {
          _vm.copyFavory($event, fav);
        }
      }
    })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(fav.name))])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92a4916e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/Favorite.vue
// module id = 3319
// module chunks = 0